import app from './modules/app/duck';
import clientConfig from './modules/client-config/duck';
import outcodes from './modules/outcodes/duck';
import areas from './modules/areas/duck';
import staff from './modules/staff/duck';
import queued from './modules/queued/duck';
import jobs from './modules/jobs/duck';
import common from './modules/common/duck';
import jobDetail from './modules/job-detail/duck';
import shipperOrderDetail from './modules/shipper-order-detail/duck';
import journeys from './modules/journeys/duck';
import journeyStops from './modules/journey-stops/duck';
import journeyEdit from './modules/journey-edit/duck';
import journeyHandling from './modules/journey-handling/duck';
import journeyMap from './modules/journey-map/duck';
import shipperOrders from './modules/shipper-orders/duck';
import log from './modules/log/duck';
import alerts from './modules/alerts/duck';
import shipperOrderForm from './modules/shipper-order-form/duck';
import shipperOrderNew from './modules/shipper-order-new/duck';
import shipperOrderEdit from './modules/shipper-order-edit/duck';
import shipperOrderDocuments from './modules/shipper-order-documents/duck';
import recurringOrders from './modules/recurring-orders/duck';
import recurringOrdersEdit from './modules/recurring-orders-edit/duck';
import errorHandler from './modules/error-handler/duck';
import carrierSection from './modules/carrier-section/duck';
import vehicleSection from './modules/vehicle-section/duck';
import journeyHistoricalRoutes from './modules/journey-historical-routes/duck';
import driverJourneys from 'modules/driver-journeys/redux/duck';

const reducers = {
  app,
  clientConfig,
  outcodes,
  areas,
  staff,
  queued,
  jobs,
  common,
  jobDetail,
  shipperOrderDetail,
  journeys,
  journeyStops,
  journeyEdit,
  journeyHandling,
  journeyMap,
  shipperOrders,
  log,
  shipperOrderForm,
  shipperOrderNew,
  shipperOrderEdit,
  shipperOrderDocuments,
  recurringOrders,
  recurringOrdersEdit,
  alerts,
  errorHandler,
  carrierSection,
  vehicleSection,
  driverJourneys,
  journeyHistoricalRoutes,
};

export default reducers;
